import React from 'react'
import { buildImageResourceUrlByKey } from '../../utils/images'
import EmptyImage from './EmptyImage'

function safeLookup(src) {
  try {
    const key = src.split('/images/')[1]
    return buildImageResourceUrlByKey(key) || src
  } catch (e) {
    return src
  }
}

const Thumbnail = ({ src, alt = 'Img', style = { width: 50, height: 50, backgroundColor: '#ccc' } }) => {
  if (!src) return <EmptyImage />

  const cdnImg = safeLookup(src)

  return (
    <img
      alt={alt}
      style={style}
      src={cdnImg}
      key={src}
      onError={event => {
        event.target.src = src // eslint-disable-line no-param-reassign
      }}
    />
  )
}

export default Thumbnail
